import { useTheme } from '@mui/material';

export const Medal = ({ color = '#f000ff' }) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={75}
      height={75}
      viewBox="0 0 375 375"
    >
      <defs>
        <clipPath id="o">
          <path d="m363.793 259.832-45.39 29.125-23.919-37.277 45.391-29.125zm0 0" />
        </clipPath>
        <clipPath id="a">
          <path d="M28.367 6H346.5v360H28.367zm0 0" />
        </clipPath>
        <clipPath id="c">
          <path d="M28.371 6h317.996v361H28.371zm0 0" />
        </clipPath>
        <clipPath id="d">
          <path d="m204.863 11.348 124.008 72.238a35.255 35.255 0 0 1 17.496 30.46v144.716a35.255 35.255 0 0 1-17.496 30.46l-124.008 72.239a34.752 34.752 0 0 1-34.992 0L45.867 289.223a35.255 35.255 0 0 1-17.496-30.461V114.047a35.255 35.255 0 0 1 17.496-30.461l124.004-72.238a34.752 34.752 0 0 1 34.992 0zm0 0" />
        </clipPath>
        <clipPath id="e">
          <path d="M107 171h234v196H107zm0 0" />
        </clipPath>
        <clipPath id="f">
          <path d="M363.79 262.336 160.054 380.098l-52.758-91.274L311.03 171.062zm0 0" />
        </clipPath>
        <clipPath id="g">
          <path d="m340.066 276.047-156.293 90.34-76.476-77.563L311.03 171.062zm0 0" />
        </clipPath>
        <clipPath id="h">
          <path d="M288 150h58v66h-58zm0 0" />
        </clipPath>
        <clipPath id="i">
          <path d="m371.5 198.77-51.73 33.19-31-48.315 51.73-33.192zm0 0" />
        </clipPath>
        <clipPath id="j">
          <path d="m345.637 215.363-56.867-31.718 51.73-33.192zm0 0" />
        </clipPath>
        <clipPath id="k">
          <path d="M296 185h46v52h-46zm0 0" />
        </clipPath>
        <clipPath id="l">
          <path d="m363.79 222.117-44.345 28.453-23.363-36.414 44.344-28.453zm0 0" />
        </clipPath>
        <clipPath id="m">
          <path d="m341.617 236.344-45.535-22.188 44.344-28.453zm0 0" />
        </clipPath>
        <clipPath id="n">
          <path d="M294 222h48v53h-48zm0 0" />
        </clipPath>
        <clipPath id="b">
          <path d="M204.938 11.336 329 83.52a35.206 35.206 0 0 1 17.5 30.433v144.594A35.206 35.206 0 0 1 329 288.98l-124.063 72.18a34.792 34.792 0 0 1-35.003 0L45.87 288.98a35.21 35.21 0 0 1-17.504-30.433V113.953A35.21 35.21 0 0 1 45.871 83.52l124.063-72.184a34.81 34.81 0 0 1 35.004 0zm0 0" />
        </clipPath>
        <clipPath id="p">
          <path d="m341.098 274.395-46.614-22.715 45.391-29.125zm0 0" />
        </clipPath>
        <clipPath id="q">
          <path d="M145 296h51v57h-51zm0 0" />
        </clipPath>
        <clipPath id="r">
          <path d="m220.2 336.656-48.677 31.23-25.648-39.976 48.676-31.23zm0 0" />
        </clipPath>
        <clipPath id="s">
          <path d="m195.863 352.27-49.988-24.36 48.676-31.23zm0 0" />
        </clipPath>
        <clipPath id="t">
          <path d="M77 303h103v60H77zm0 0" />
        </clipPath>
        <clipPath id="u">
          <path d="m92.242 277.57 101.719 59.14-14.82 25.485L77.42 303.06zm0 0" />
        </clipPath>
        <clipPath id="v">
          <path d="m143.102 307.14 36.039 55.055L77.42 303.06zm0 0" />
        </clipPath>
        <clipPath id="w">
          <path d="M79 287h50v23H79zm0 0" />
        </clipPath>
        <clipPath id="x">
          <path d="m82.23 284.266 48.02 5.586-2.238 19.242-48.02-5.59zm0 0" />
        </clipPath>
        <clipPath id="y">
          <path d="m106.242 287.059 21.77 22.035-48.02-5.59zm0 0" />
        </clipPath>
        <clipPath id="z">
          <path d="M187 301h113v67H187zm0 0" />
        </clipPath>
        <clipPath id="A">
          <path d="M179.332 354.242 291.73 287.63l8.086 13.648-112.398 66.61zm0 0" />
        </clipPath>
        <clipPath id="B">
          <path d="m235.531 320.938 64.285-19.66-112.398 66.609zm0 0" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)">
        <g clipPath="url(#b)">
          <path fill={color} d="M28.367 1.152H346.5v370.192H28.367zm0 0" />
        </g>
      </g>
      <g clipPath="url(#c)">
        <g clipPath="url(#d)">
          <path
            fill="none"
            stroke={theme.palette.medal.main}
            strokeWidth={16}
            d="m235.42 13.58 165.41 96.235a46.955 46.955 0 0 1 23.338 40.58v192.788a46.955 46.955 0 0 1-23.337 40.58L235.42 480a46.405 46.405 0 0 1-46.675 0L23.339 383.763a46.955 46.955 0 0 1-23.337-40.58V150.395a46.955 46.955 0 0 1 23.337-40.58L188.745 13.58a46.405 46.405 0 0 1 46.675 0zm0 0"
            transform="matrix(.7497 0 0 .75064 28.37 1.154)"
          />
        </g>
      </g>
      <path
        fill={theme.palette.primary.main}
        d="m160.429 168.442-.25-46.328-22.469 37.719h-10.984l-22.36-36.47v45.079h-22.86V81.036h20.36l30.719 50.437 29.969-50.437h20.36l.25 87.406zm135.849-16.276h-12.969v16.703h-24.062v-16.703h-46.141v-16.094l39.156-54.484h25.563l-35.532 51h17.704v-14.844h23.312v14.844h12.969zm0 0"
      />
      <path
        fill="none"
        stroke={theme.palette.medal.main}
        strokeWidth={6}
        d="m0 3 406.841.002"
        transform="matrix(.64896 -.3766 .37644 .64869 76.608 301.66)"
      />
      <g clipPath="url(#e)">
        <g clipPath="url(#f)">
          <g clipPath="url(#g)">
            <path
              fill={theme.palette.medal.main}
              d="M363.79 262.336 160.054 380.098l-52.758-91.274L311.03 171.062zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#h)">
        <g clipPath="url(#i)">
          <g clipPath="url(#j)">
            <path
              fill={theme.palette.medal.main}
              d="m371.5 198.77-51.73 33.19-31-48.315 51.73-33.192zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#k)">
        <g clipPath="url(#l)">
          <g clipPath="url(#m)">
            <path
              fill={theme.palette.medal.main}
              d="m363.79 222.117-44.345 28.453-23.363-36.414 44.344-28.453zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#n)">
        <g clipPath="url(#o)">
          <g clipPath="url(#p)">
            <path
              fill={theme.palette.medal.main}
              d="m363.793 259.832-45.39 29.125-23.919-37.277 45.391-29.125zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#q)">
        <g clipPath="url(#r)">
          <g clipPath="url(#s)">
            <path
              fill={theme.palette.medal.main}
              d="m220.2 336.656-48.677 31.23-25.648-39.976 48.676-31.23zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#t)">
        <g clipPath="url(#u)">
          <g clipPath="url(#v)">
            <path
              fill={theme.palette.medal.main}
              d="m92.242 277.57 101.719 59.14-14.82 25.485L77.42 303.06zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#w)">
        <g clipPath="url(#x)">
          <g clipPath="url(#y)">
            <path
              fill={theme.palette.medal.main}
              d="m82.23 284.266 48.02 5.586-2.238 19.242-48.02-5.59zm0 0"
            />
          </g>
        </g>
      </g>
      <path
        fill={theme.palette.primary.main}
        d="m160.484 294.227-.25-46.203-22.422 37.61h-10.953l-22.297-36.36v44.953H81.781v-87.172h20.297l30.64 50.313 29.875-50.313h20.313l.234 87.172zm134.581-87.402v87.625h-24.782v-34.172h-33.796v34.172h-24.782v-87.625h24.782v32.922h33.796v-32.922zm0 0"
      />
      <g clipPath="url(#z)">
        <g clipPath="url(#A)">
          <g clipPath="url(#B)">
            <path
              fill={theme.palette.medal.main}
              d="M179.332 354.242 291.73 287.63l8.086 13.648-112.398 66.61zm0 0"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
